export const globalVar = {
    sedeLisboa : "Campo Grande 28 4B - 1700-093 Lisboa",
    sedeLisboaMaps : "https://goo.gl/maps/UfkhvaH2gptrMGnW8",
    sedePorto: "Rua Gonçalo Cristóvão,185 R/C 4000-269 Porto",
    sedePortoMaps: "https://goo.gl/maps/oD9c5394ii8HrEkWA",
    numeroTlmLisboa: "+351 217 961 493",
    email: "geral@grupoinveste.pt",
}